import {
    put,
    call,
    takeLatest,
} from 'redux-saga/effects';
import axios from 'axios';
import {LIST_PRODUCT_COSTS} from "../../constants/productCosts";
import {hideError, showErrorMessage} from "../../actions/global";
import {SERVER_FAILED_ERROR_MESSAGE} from "../../../pages/Dashboard/DashboardFinal/constants";
import {storeProductCosts} from "../../actions/productCosts";
import {PRODUCT_COST} from "../../../components/global/Server/endpoints";

const getRequest = (endpoint) => {
    return axios.get(endpoint, {
        headers: {
            "Authorization": `Bearer ${localStorage.getItem('token')}`
        }
    })
        .then(response => response);
}

function* listProductCostsSaga() {
    yield put(hideError())
    try {
        const response = yield call(() => getRequest(PRODUCT_COST.LIST_PRODUCT_COSTS))
        yield put(storeProductCosts(response.data))
    } catch (error) {
        yield put(showErrorMessage(SERVER_FAILED_ERROR_MESSAGE))
    }
}

export default function* productCostsSagas() {
    yield takeLatest(LIST_PRODUCT_COSTS, listProductCostsSaga);
}